import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import getStockStatus from 'Api/stock-promo/getStockStatus';
import getStockStatusResponse from './model/response/getStockStatusResponse';

const useGetStockStatus = () => {
  const { t } = useTranslation('host-stock-promo');

  return useQuery({
    queryKey: ['all-stock-status', t],
    queryFn: async () => {
      const response = await getStockStatus();

      const result = getStockStatusResponse(response, t);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetStockStatus;
